export const mentionStyle: React.CSSProperties = {
  fontWeight: 'normal',
  zIndex: 2,
  position: 'relative',
  color: '#2449fc',
};

export const mentionListStyle = {
  control: {
    backgroundColor: 'transparent',
    fontSize: '14px',
    fontWeight: 'normal',
  },
  '&multiLine': {
    control: {
      fontFamily: 'Schibsted Grotesk',
      border: 'none',
    },
    highlighter: {
      border: 'none',
    },
    input: {
      border: 'none',
      outline: 'none',
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: '14px',
      maxHeight: '300px',
      overflowY: 'auto',
    },
    item: {
      padding: '5px 15px',
      '&focused': {
        backgroundColor: '#E0F9F9',
        color: '#00CECF',
      },
    },
  },
};

export const mentionListReplyStyle = {
  control: {
    backgroundColor: '#F6F6F6',
    fontSize: '14px',
    fontWeight: 'normal',
  },
  '&multiLine': {
    control: {
      fontFamily: 'Schibsted Grotesk',
      border: 'none',
    },
    highlighter: {
      border: 'none',
    },
    input: {
      border: 'none',
      outline: 'none',
    },
  },
  suggestions: {
    list: {
      backgroundColor: 'white',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: '14px',
    },
    item: {
      padding: '5px 15px',
      '&focused': {
        backgroundColor: '#E0F9F9',
        color: '#00CECF',
      },
    },
  },
};
